import { useTranslation } from 'react-i18next';
import { OpenedModalUnionType } from '../..';

const TRANS_PATH = 'COMPANY_LINKS.MODAL_TITLE';

export const useModalTitle = (
  openedModal: OpenedModalUnionType | null
): string => {
  const { t } = useTranslation('personDetailsGeneral');

  switch (openedModal) {
    case 'ADD_COMPANY_LINK':
      return t(`${TRANS_PATH}.ADD_COMPANY_LINK`);
    case 'ADD_FREELANCER':
      return t(`${TRANS_PATH}.ADD_FREELANCER`);
    case 'EDIT_COMPANY_LINK':
      return t(`${TRANS_PATH}.EDIT_COMPANY_LINK`);
    case 'EDIT_FREELANCER':
      return t(`${TRANS_PATH}.EDIT_FREELANCER`);
    default:
      return '';
  }
};
